<ng-container *ngFor="let segment of serviceSegmentItems$ | async; let lastSegment = last">
  <fin-dapi-included-product-heading
    class="block ps-xsmall-y nordic-blue-25-bg rounded-medium"
    [locationCodes]="[segment.departure.locationCode, segment.arrival.locationCode]"
    [operatedByText]="
      segment.operatingAirline.code !== 'AY' && ('operatedBy' | finLocalization: [segment.operatingAirline.name])
    "
    [locations]="(cartOrOrder$ | async).locations"
  >
  </fin-dapi-included-product-heading>

  <ul class="no-list-style">
    <ng-container *ngFor="let pax of segment.passengers; let last = last">
      <li class="pr-small-t" [class.pr-small-b]="!last || !lastSegment" [class.border-bottom-dotted]="!last">
        <div class="ms-small-l">
          <div data-hj-suppress class="ps-xsmall-b font-body-1">
            <ng-container *ngTemplateOutlet="paxInfo; context: { pax: pax }"></ng-container>
          </div>

          <fin-grouped-services
            class="mr-xsmall-l block"
            [groupedServices]="pax.groupedServices"
          ></fin-grouped-services>
        </div>
      </li>
    </ng-container>
  </ul>
</ng-container>

<ng-template #paxInfo let-pax="pax">
  <ng-container *ngIf="!pax.associatedInfantName">{{ pax.firstName }} {{ pax.lastName }}</ng-container>
  <ng-container *ngIf="pax.associatedInfantName">{{
    'MMB.labels.travellingWithInfant'
      | finLocalization: { firstName: pax.firstName, lastName: pax.lastName, infantName: pax.associatedInfantName }
  }}</ng-container>
</ng-template>
